import BackendLayout from "../../layouts/BackendLayout";
import Select2 from "../../components/Select2";
import React, {useEffect, useState} from "react";
import Pagination from "../../components/Pagination";
import Machine from "../../components/Machine";
import {useDocumentTitle} from "../../hooks";
import {PageTitle} from "../../components/admin";
import {useDispatch, useSelector} from "react-redux";
import getPageBreadcrumb from "../../services/BreadcrumbServices";
import {MACHINE_INPUT} from "../../constants/routes";
import {getMachineInputPageSettings} from "../../api/setting/pageApi";
import {setPageSettings} from "../../store/actions/pageActions";
import StepBar from "../../components/StepBar";
import {
  ArrayUtils,
  getAlertErrorMessage,
  getInputErrorMessage,
  hasErrorInput,
} from "../../utils";
import {
  TextInput,
  Label,
  CheckboxInput,
  FormGroup,
  FormGroupInput,
  FormGroupVerticalInput,
  Button,
  ButtonDPad,
  RedirectAlert
} from "../../components";
import {
  setButtonProcessing,
  clearButtonProcessing,
  clearPageLoading,
  setPageLoading,
  setComponentLoading,
  clearComponentLoading
} from '../../store/actions';
import {getSelectedValue} from "../../utils/select-utils";
import {searchMachines, searchByMachine} from "../../services/inspection/MachineInput"
import {updateUserSetting} from "../../services/user-master/UserSettingServices"
import {errorStatusHandle} from "../../utils";
import {useNavigate} from 'react-router-dom';
import {
  BUTTON_SEARCH_MACHINE_INPUT,
} from "../../constants/buttons";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import {USER_SETTING_CATEGORIES} from "../../constants/app";
import {Tabs} from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {MACHINE_INPUT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function MachineInputPage() {
  useRedirectPage(MACHINE_INPUT_PAGE);
  const stepBarItems = [
    {spanText: '設備入力', isActive: true},
    {spanText: '点検結果登録', notPassed: true, isBack: true}
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const breadcrumb = getPageBreadcrumb(MACHINE_INPUT);
  const [machineData, setMachineData] = useState([]);
  const [formError, setFormError] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [inputOptions, setInputOptions] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [machineName, setMachineName] = useState('');
  const [tab, setTab] = useState(null);
  const [dataSearch, setDataSearch] = useState({
    group_1: '',
    group_2: '',
    group_3: '',
    group_4: '',
    group_5: '',
    template_id: '',
    hide_inspected: 1,
    page: 1,
    per_page: 20
  });
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const machineInputMethod = useSelector((s) => s.app_settings.machine_input_methods);

  const setMachineInputPageSettings = async () => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getMachineInputPageSettings();
      if (pageSettings.user_setting?.setting) {
        setDataSearch(handleSetDataSearch(pageSettings.user_setting.setting, pageSettings.input_options));
        setTab(pageSettings.user_setting.setting.tab);
      } else {
        setTab('text');
      }
      setInputOptions(pageSettings.input_options);
      setTemplates(formatOptionTemplate(pageSettings.input_options.templates));
      dispatch(setPageSettings(pageSettings));
    } catch (e) {
      errorStatusHandle(e)
    } finally {
      dispatch(clearPageLoading());
    }
  };

  const handleSetDataSearch = (userSettings, dataOptions) => {
    Object.keys(userSettings).forEach(key => {
      if (key.startsWith('group_') || key === 'template_id') {
        const optionsKey = (key === 'template_id' ? 'templates' : key);

        if (dataOptions[optionsKey]) {
          const isValidGroupValue = dataOptions[optionsKey].some(option => {
            const userSettingValue = userSettings[key];

            if (Array.isArray(userSettingValue)) {
              return userSettingValue.includes(option.id)
            }
            return option.id === userSettingValue;
          });

          if (!isValidGroupValue) {
            userSettings[key] = '';
          }
        } else {
          userSettings[key] = '';
        }
      }
    });
    return userSettings;
  };

  const updateSettings = async () => {
    try {
      const userSettingsData = {...dataSearch, tab: tab};
      await updateUserSetting(userSettingsData, USER_SETTING_CATEGORIES.MACHINE_INPUT);
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === 400) {
        setFormError(e.data)
      }
    }
  };

  useEffect(() => {
    setMachineInputPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getOptionsForTemplate();
    if (dataSearch.template_id !== '') {
      handleSearch();
    } else {
      setMachineData([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch]);

  const uniqueNameGroupOptions = (options) => {
    const seenLabels = {};
    return options.reduce((result, {value, label}) => {
      const normalizedLabel = label.toUpperCase();
      if (!seenLabels[normalizedLabel]) {
        seenLabels[normalizedLabel] = value;
        result.push({value, label})
      } else {
        if (typeof seenLabels[normalizedLabel] === 'number') {
          seenLabels[normalizedLabel] = [seenLabels[normalizedLabel], value];
        } else {
          seenLabels[normalizedLabel].push(value);
        }
        result.find(opt => opt.label.toUpperCase() === normalizedLabel).value = seenLabels[normalizedLabel];
      }
      return result;
    }, [])
  };

  const handleSelectChange = (key, selectedValue) => {
    setDataSearch((prevState) => {
      let newSelectedGroups = {...prevState};
      newSelectedGroups[key] = selectedValue;

      const groupNumber = parseInt(key.split('_')[1], 10);
      for (let i = groupNumber + 1; i <= 5; i++) {
        newSelectedGroups[`group_${i}`] = '';
      }

      if (key !== 'template_id') {
        newSelectedGroups['template_id'] = '';
      }
      newSelectedGroups['hide_inspected'] = 1;
      return newSelectedGroups;
    });
    setFormError([]);
    setMachineName('')
  };

  const allGroupIsEmpty = () => {
    return Object.keys(dataSearch).filter(key => key.startsWith('group_')).every(key => dataSearch[key] === '');
  };

  const firstGroupNumberNonEmpty = () => {
    return Object.entries(dataSearch)
      .find(([key, value]) => key.startsWith('group_') && value !== '')?.[0]?.replace('group_', '') || -1;
  };

  const getOptionsForGroup = (groupNumber, parentGroupId) => {
    const groupKey = `group_${groupNumber}`;
    const groupOptions = inputOptions[groupKey] || [];
    const noneOptions = [{value: '', label: '[ALL]'}];

    if (allGroupIsEmpty()) {
      const allOptions = groupOptions.map((option) => ({value: option.id, label: option.name}));
      return noneOptions.concat(uniqueNameGroupOptions(allOptions));
    }

    if (!parentGroupId) {
      if (groupNumber <= firstGroupNumberNonEmpty()) {
        const allOptions = groupOptions.map((option) => ({value: option.id, label: option.name}));
        return noneOptions.concat(uniqueNameGroupOptions(allOptions))
      }
      return noneOptions;
    } else {
      const hasManyParentGroupId = Array.isArray(parentGroupId);
      let filteredOptions;
      if (hasManyParentGroupId) {
        filteredOptions = groupOptions.filter((option) => parentGroupId.includes(option.parent_group_id));
      } else {
        filteredOptions = groupOptions.filter((option) => option.parent_group_id === parentGroupId);
      }
      const formatOptions = filteredOptions.map((option) => ({value: option.id, label: option.name}));
      return noneOptions.concat(uniqueNameGroupOptions(formatOptions))
    }
  };

  const getOptionsForTemplate = () => {
    const templateOptions = inputOptions['templates'] || [];
    if (allGroupIsEmpty()) {
      setTemplates(formatOptionTemplate(templateOptions))
    } else {
      const filteredTemplates = templateOptions.filter(template => {
        return Object.keys(dataSearch).every(key => {
          if (key.startsWith('group_') && dataSearch[key] !== '' && template[key] !== null) {
            if (Array.isArray(dataSearch[key])) {
              return dataSearch[key].includes(template[key].id);
            } else {
              return dataSearch[key] === template[key].id;
            }
          }
          return true;
        });
      });
      setTemplates(formatOptionTemplate(filteredTemplates))
    }
  };


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e)
    }
  };

  const handleSubmit = async (e) => {
    dispatch(setButtonProcessing(BUTTON_SEARCH_MACHINE_INPUT));
    e.preventDefault();
    try {
      const response = await searchByMachine({
        group_1: dataSearch.group_1,
        group_2: dataSearch.group_2,
        group_3: dataSearch.group_3,
        group_4: dataSearch.group_4,
        group_5: dataSearch.group_5,
        template_id: dataSearch.template_id,
        machine: machineName
      });
      if (response.data.machine && response.data.machine.link) {
        updateSettings();
        navigate(response.data.machine.link)
      }
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === 400) {
        setFormError(e.data)
      }
    } finally {
      dispatch(clearButtonProcessing(BUTTON_SEARCH_MACHINE_INPUT));
    }
  };

  const handleSearch = async () => {
    dispatch(setComponentLoading("machine-input"));
    try {
      const response = await searchMachines(dataSearch);
      setMachineData(response.data.machines);
      setTotalPage(response.data.pagination.total_pages);
      setTotalCount(response.data.pagination.total_count);
      setFormError([]);
    } catch (e) {
      errorStatusHandle(e);
      if (e.status === 400) {
        setFormError(e.data)
      }
    } finally {
      dispatch(clearComponentLoading("machine-input"));
    }
  };

  const handlePageChange = (page) => {
    setDataSearch(prev => ({...prev, page}));
  };

  const handleCheckboxChange = (event) => {
    setDataSearch(prevState => ({
      ...prevState,
      hide_inspected: event.target.checked ? 1 : 0
    }));
  };

  const formatOptionTemplate = (data) => {
    const noneOptions = [{value: '', label: ''}];
    if (!data || data.length === 0) {
      return noneOptions
    }

    return data.map(item => ({
      value: item.id,
      label: item.name
    }))
  };

  const getSelectedGroupValue = (options, value, nullIsAll = false) => {
    if (!options) {
      return null;
    }
    if (Array.isArray(value)) {

    }
    let propName = 'value';
    let option = options.find(o => {
      return String(o[propName]) === String(value)
    });
    if (option) {
      return option;
    }
    if (Array.isArray(value)) {
      return options.find(o => {
        return value.includes(o[propName])
      });
    }
    if (nullIsAll) {
      return {value: null, label: '[ALL]'}
    }
    return null;
  };

  const renderMachineInputFormSearch = (method) => (
    <>
      <Label text={method === 'text' ? '点検テンプレートを選択し、設備名を入力してください' : '点検テンプレートを選択し、リスト内の設備名をクリックしてください\n'}
             className="2xl:text-[18px] xl:text-[17px] text-[15px] mb-[12px] !font-light" htmlFor="machine_name"/>
      <div className="flex xl:space-x-[24px] space-x-[12px] w-full">
        {ArrayUtils.range(1, 5).map((i, idx) => {
          if (groupSettings[`group_${i}`]?.active) {
            const parentGroupId = i > 1 ? dataSearch[`group_${i - 1}`] : null;
            const options = getOptionsForGroup(i, parentGroupId);
            return (
              <FormGroup key={idx} direction="vertical" className="w-fit">
                <Label text={groupSettings[`group_${i}`]?.name} htmlFor={`group_${i}`}
                       className="mb-[4px] whitespace-nowrap"/>
                <FormGroupInput className="flex-col" error={getAlertErrorMessage(formError.errors, `group_${i}`)}>
                  <Select2 name={`group_${i}`} options={options} heightSelect="42px" className='xl:min-w-[200px] min-w-[180px] w-full lg:max-w-[240px] max-w-[228px]'
                           value={getSelectedGroupValue(options, dataSearch[`group_${i}`])}
                           onChange={(option) => handleSelectChange(`group_${i}`, option.value)} placeholder=""
                           hasError={hasErrorInput(formError.errors, `group_${i}`)}/>
                </FormGroupInput>
              </FormGroup>
            )
          }
          return null
        })}
        <FormGroup direction="vertical">
          <Label text="点検テンプレート名" htmlFor="template_id" className="mb-[4px] whitespace-nowrap" required={true}/>
          <FormGroupInput className="flex-col" error={getAlertErrorMessage(formError.errors, 'template_id')}>
            <Select2 name="template_id" options={templates} className="xl:w-[256px] lg:w-[210px] w-[188px]" heightSelect="42px"
                     value={getSelectedValue(templates, dataSearch['template_id'])}
                     onChange={(option) => handleSelectChange('template_id', option.value)} placeholder=""
                     hasError={hasErrorInput(formError.errors, 'template_id')}/>
          </FormGroupInput>
        </FormGroup>
      </div>
    </>
  );

  const renderMachineInputMethodText = () => (
    <div className="p-[24px] border border-[#e0e0e0] bg-white w-fit">
      {renderMachineInputFormSearch('text')}
      <FormGroup direction="vertical" labelWidth="w-full" className="mt-[12px]">
        <FormGroupVerticalInput error={getInputErrorMessage(formError.errors, "machine")}>
          <Label text="設備名" htmlFor="machine-name" required={true}
                 className="w-[160px] mb-[4px]"/>
          <FormGroupInput>
            <TextInput
              className="2xl:text-base xl:text-[15px] text-[14px] w-[300px]"
              name="machine" autoFocus
              maxLength={200}
              nextFocus={false}
              onKeyPress={handleKeyPress}
              id="machine" value={machineName} onChange={(e) => setMachineName(e.target.value)}
              hasError={hasErrorInput(formError.errors, "machine")}/>
            <Button color="primary" type="submit" className="min-w-[120px] ml-[12px]" id={BUTTON_SEARCH_MACHINE_INPUT}
                    onClick={(e) => handleSubmit(e)}>
              次へ
            </Button>
          </FormGroupInput>
        </FormGroupVerticalInput>
      </FormGroup>
    </div>
  );

  const renderMachineInputMethodSelect = () => (
    <div className="p-[24px] border border-[#e0e0e0] bg-white w-fit">
      {renderMachineInputFormSearch('select')}
      <div className="relative mt-[12px]">
        <LoadingSpinner component="machine-input"/>
        {machineData.length > 0 ? (
          <>
            <div className="mt-[16px]">
              <div
                className="flex flex-wrap gap-[18px] mb-[18px] 2xl:max-w-[1120px] xl:max-w-[1020px] lg:max-w-[700px] max-w-[640px]">
                {machineData.map((machine, index) => (
                  <Machine key={index} item={machine} updateSettings={updateSettings}/>
                ))}
              </div>
            </div>
          </>
        ) : (
          <p
            className="bg-[#F9FAFB] p-[8px] text-[#344054] rounded-lg border border-[#e0e0e0] 2xl:text-[18px] xl:text-[17px] text-[16px] 2xl:mb-[24px] xl:mb-[20px] mb-[16px] w-fit">該当する検索結果が見つかりませんでした。別の検索条件をお試しください。
          </p>
        )}
        <div className="flex items-center justify-between flex-wrap">
          <CheckboxInput name="hide_inspected" id="hide_inspected" checked={dataSearch.hide_inspected}
                         onChange={handleCheckboxChange} label="点検済みの設備は表示しない"/>
          {machineData.length > 0 ? (
            <Pagination
              pageSize={20}
              setPage={handlePageChange}
              currentPage={dataSearch.page}
              numPages={totalPage}
              totalCount={totalCount}
              customStyles="mt-0" showIndex={false}
            />
          ) : (
            null
          )}
        </div>
      </div>
    </div>
  );

  const handleTabChange = (e) => {
    setTab(e ? 'select' : 'text');
  };

  useDocumentTitle("設備入力 - 点検王");
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="設備入力"/>
      <StepBar stepBarItems={stepBarItems}/>
      <ButtonDPad/>
      <div className="mt-[30px]">
        <RedirectAlert />
      </div>
      <div className="mt-[12px] sm:mr-[24px] md:mr-[24px] mr-0 inline-block">
        {tab !== null && (
          <Tabs    style="pills"
                   className="focus-visible:outline-none"
                   theme={tenkenTheme.machine_input_tabs}
                   onActiveTabChange={(e) => handleTabChange(e)}
          >
            {machineInputMethod?.text && (
              <Tabs.Item
                title={`テキスト入力`}
                active={tab === 'text'}
                key={1}
                className="focus-visible:outline-none"
              >
                {renderMachineInputMethodText()}
              </Tabs.Item>
            )}
            {machineInputMethod?.select && (

              <Tabs.Item
                title={`リストから選択`}
                active={tab === 'select'}
                key={2}
              >
                {renderMachineInputMethodSelect()}
              </Tabs.Item>
            )}
          </Tabs>
        )}
      </div>
    </BackendLayout>
  );
}
